// extracted by mini-css-extract-plugin
export default {"title":"news-feed-list_title__OM5h3","root":"news-feed-list_root__iMthP","inActive":"news-feed-list_inActive__CzaDG"};